module.exports = __webpack_public_path__ + "static/media/booklet_edited.8b4a9c83.mov";